angular.module('bb.util').factory('ModalService', ModalService);

ModalService.$inject = [
  '$rootScope',
  'ListingViewService',
  'AppointmentBookService',
  'FeedbackService',
  'UtilService',
  'OfferService',
  '$q',
  'ErrorService',
  '$sce',
  'userService',
  'AppointmentConfigService',
  'appointmentListsService',
];
function ModalService(
  $rootScope,
  ListingViewService,
  AppointmentBookService,
  FeedbackService,
  UtilService,
  OfferService,
  $q,
  ErrorService,
  $sce,
  userService,
  AppointmentConfigService,
  appointmentListsService,
) {
  const previewModal = {
    open: false,
  };

  const networkModal = {
    open: false,
  };

  const appointmentModal = {
    open: false,
  };

  const appointmentConfigModal = {
    open: false,
    openEventListeners: [],
    closeEventListeners: [],
  };

  const assetModal = {
    open: false,
  };

  const multiConfModal = {
    open: false,
    contacts: null,
    listingContacts: null,
    listingId: null,
  };

  const questionEditModal = {
    open: false,
  };

  const offerModal = {
    open: false,
  };

  const folderModal = {
    open: false,
  };

  const playerModal = {
    open: false,
  };

  const addVideoModal = {
    open: false,
  };

  const appointmentFilterModal = {
    open: false,
  };

  const userActionModal = {
    open: false,
  };

  const contactModal = {
    open: false, // not used
    changeEventListeners: [],
  };

  function clearPreviewModal() {
    previewModal.open = false;
    previewModal.listing = null;
    previewModal.listingLocationDetails = '';
  }

  function clearNetworkModal() {
    networkModal.open = false;
    networkModal.listing = null;
  }

  function clearAppointmentModal() {
    appointmentModal.isEditingFeedback = false;
    appointmentModal.open = false;
    appointmentModal.appointment = null;
    appointmentModal.listing = null;
    appointmentModal.emailDeliveryLog = null;
    appointmentModal.textDeliveryLog = null;
    appointmentModal.pushNotificationDeliveryLog = null;
    appointmentModal.listingLink = null;
    appointmentModal.feedback = null;
  }

  function clearAppointmentConfigModal() {
    appointmentConfigModal.open = false;
    appointmentConfigModal.closeEventListeners.forEach(fn => fn());
    appointmentConfigModal.appointment = null;
    appointmentConfigModal.appointmentConfig = null;
    appointmentConfigModal.onSave = null;
  }

  function clearMultiConfModal() {
    multiConfModal.contacts = null;
    multiConfModal.listingContacts = null;
    multiConfModal.listingId = null;
    multiConfModal.open = false;
  }

  function clearQuestionEditModal() {
    questionEditModal.question = null;
    questionEditModal.open = false;
  }

  function clearOfferModal() {
    offerModal.emailDeliveryLog = null;
    offerModal.emailPreview = null;
    offerModal.listing = null;
    offerModal.offer = null;
    offerModal.open = false;
  }

  function clearFolderModal() {
    folderModal.folder = null;
    folderModal.open = false;
  }

  function clearPlayerModal() {
    playerModal.link = null;
    playerModal.open = false;
  }

  function clearAddVideoModal() {
    addVideoModal.selectedFolderId = null;
    addVideoModal.open = false;
  }

  function clearAppointmentFilterModal() {
    appointmentFilterModal.open = false;
    appointmentFilterModal.preferences = null;
  }

  function clearUserActionModal() {
    userActionModal.open = false;
    userActionModal.userId = null;
    userActionModal.actions = null;
    userActionModal.count = null;
  }

  $rootScope.$on('$locationChangeStart', () => {
    const modal = $('.modal.in');
    if (modal.length) {
      modal.modal('hide');
    }
  });

  $('#preview-modal').on('hidden.bs.modal', () => {
    clearPreviewModal();
    $rootScope.$apply();
  });

  $('#appointment-modal').on('hidden.bs.modal', () => {
    clearAppointmentModal();
    $rootScope.$apply();
  });

  function openAssetModal({ index, assets }) {
    assetModal.open = true;
    assetModal.index = index;
    assetModal.assets = assets;
  }

  // the idea when opening modals is to put all the state into the controller
  // this includes all the loading data.
  // in the preview modal you can dereference using
  // vm.previewModal = ModalService.previewModal;
  // vm.previewModal.attribute
  function openPreviewModal(listing) {
    $('#preview-modal').modal({ keyboard: true });
    previewModal.open = true;
    previewModal.listing = listing;
    previewModal.listingLink = `listing/${listing.id}/view`;
    const { location, org, reps } = listing;
    const { addresses, locations } = org;

    if (locations) {
      previewModal.listingLocationDetails = `${locations[location].name}`;
      if (reps && reps.length > 0) {
        const { address } = reps[0];
        const { name } = addresses?.[location]?.[address];
        if (name) {
          previewModal.listingLocationDetails += ` - ${name}`;
        }
      }
    }
  }

  function openNetworkModal(listingId) {
    ListingViewService.getListing(listingId).then(data => {
      networkModal.listing = data;
      $('#network-modal').modal({ keyboard: true });
      networkModal.open = true;
    });

    return $q(resolve => {
      $('#network-modal').on('hidden.bs.modal', () => {
        clearNetworkModal();
        resolve(networkModal.remove);
        $('#network-modal').off();
      });
    });
  }

  function openAppointmentModal(appointmentId, listingId, tabToOpen, options) {
    function fetchData() {
      const promises = [
        AppointmentBookService.getAppointmentDetails(appointmentId),
        AppointmentBookService.getAppointmentConfigContact(
          listingId,
          $rootScope.auth.id,
        ),
        AppointmentBookService.queryAppointmentEmailDelivery(appointmentId),
        AppointmentBookService.queryAppointmentTextDelivery(appointmentId),
        AppointmentBookService.queryAppointmentPushNotificationDelivery(
          appointmentId,
        ),
        FeedbackService.getFeedback(appointmentId, listingId),
        UtilService.getServerDate(),
        AppointmentConfigService.getListingAppointmentConfig(listingId),
        appointmentListsService.getPermission(listingId),
      ];

      $q.all(promises)
        .then(
          ([
            appointmentDetails,
            appointmentConfigContact,
            emailDeliveryLog,
            textDeliveryLog,
            pushNotificationDeliveryLog,
            feedback,
            { date },
            appointmentConfig,
            permission,
          ]) => {
            let mustCall = false;
            appointmentConfig.contacts.forEach(contact => {
              if (
                contact.phone &&
                contact.phone.filter(phoneInfo => phoneInfo.mustCall).length
              ) {
                mustCall = true;
              }
            });
            appointmentModal.appointment = appointmentDetails.appointment;
            appointmentModal.appointmentConfigContact =
              appointmentConfigContact;
            appointmentModal.appointment.listing.thumbnail =
              appointmentDetails.listing.thumbnail;
            appointmentModal.listing = appointmentDetails.listing;
            appointmentModal.emailDeliveryLog = emailDeliveryLog;
            appointmentModal.textDeliveryLog = textDeliveryLog;
            appointmentModal.pushNotificationDeliveryLog =
              pushNotificationDeliveryLog;
            appointmentModal.feedback = feedback;
            appointmentModal.listingLink = `listing/${appointmentModal.listing.id}/view`;
            appointmentModal.serverDate = date;
            appointmentModal.mustCallContacts = mustCall;
            appointmentModal.permission = permission;
            appointmentModal.appointmentConfig = appointmentConfig;
          },
        )
        .catch(err => {
          ErrorService.toastyHTTPErr(err);
        })
        .finally(() => {
          appointmentModal.dataLoaded = true;
        });
    }

    $('#appointment-modal').modal({ keyboard: true });
    appointmentModal.open = true;

    // Optionally select a tab to open to
    appointmentModal.tab = tabToOpen || 'history';

    if (options) {
      if (options.additionalProps) {
        Object.assign(appointmentModal, options.additionalProps);
      }
    }

    appointmentModal.dataLoaded = false;
    fetchData();
    return $q(resolve => {
      $('#appointment-modal').on('hidden.bs.modal', () => {
        clearAppointmentModal();
        resolve(appointmentModal.updated);
        appointmentModal.updated = false;
        $('#appointment-modal').off();
      });
    });
  }

  function onOpenAppointmentConfigModal(fn) {
    appointmentConfigModal.openEventListeners.push(fn);
  }
  function openAppointmentConfigModal(appointment, appointmentConfig, onSave) {
    appointmentConfigModal.appointment = appointment;
    appointmentConfigModal.appointmentConfig = appointmentConfig;
    appointmentConfigModal.onSave = onSave;

    $('#appointment-config-modal').modal({ keyboard: true });
    appointmentConfigModal.open = true;
    appointmentConfigModal.openEventListeners.forEach(fn => fn());

    $('#appointment-config-modal').on('hidden.bs.modal', () => {
      clearAppointmentConfigModal();
      $('#appointment-config-modal').off();
    });
  }

  function openMultiConfModal(contacts, listingContacts, listingId) {
    multiConfModal.contacts = contacts.map(contact => ({ ...contact }));
    multiConfModal.listingContacts = listingContacts;
    multiConfModal.listingId = listingId;
    $('#multi-conf-modal').modal({ keyboard: true });
    multiConfModal.open = true;

    return $q(resolve => {
      $('#multi-conf-modal').on('hidden.bs.modal', () => {
        clearMultiConfModal();
        resolve(multiConfModal.updatedContacts);
        multiConfModal.updatedContacts = null;
        $('#multi-conf-modal').off();
      });
    });
  }

  function openQuestionEditModal(question) {
    questionEditModal.question = angular.copy(question);
    $('#question-edit-modal').modal({ keyboard: true });
    questionEditModal.open = true;

    $rootScope.$digest();
    return $q(resolve => {
      $('#question-edit-modal').on('hidden.bs.modal', () => {
        clearQuestionEditModal();
        resolve(questionEditModal.updatedQuestion);
        questionEditModal.updatedQuestion = null;
        $('#question-edit-modal').off();
        setTimeout(() => $rootScope.$digest(), 0);
      });
    });
  }

  function openOfferModal(listingId, offerId) {
    $('#offer-modal').modal({ keyboard: true });
    offerModal.dataLoaded = false;
    offerModal.open = true;

    offerModal.listingLink = `listing/${listingId}/view`;
    const recipientsMap = {};
    $q.all([
      OfferService.getOfferEmailPreview(listingId, offerId),
      OfferService.getOffer(listingId, offerId),
      ListingViewService.getListing(listingId),
      OfferService.getOfferNotificationLog(listingId, offerId),
      OfferService.queryOfferEmailDelivery(listingId, offerId),
    ])
      .then(
        ([
          emailPreview,
          offer,
          listing,
          offerNotificationLog,
          offerEmailDeliveryLogs,
        ]) => {
          offerModal.emailPreview = $sce.trustAsHtml(emailPreview.html);
          offerModal.offer = offer;
          offerModal.listing = listing;
          offerModal.unsubscribedAgents =
            offerNotificationLog?.agents?.unsubscribed || [];
          const potentialRecipients =
            offerNotificationLog?.agents?.recipients || [];

          potentialRecipients.forEach(recipient => {
            recipientsMap[recipient.email] = recipient;
          });

          offerModal.recipients = offerEmailDeliveryLogs.map(recipient => {
            // here ".recipient" is email address, we are using emails as keys since they
            // are unique
            return {
              ...recipient,
              name: recipientsMap[recipient.recipient]?.name,
              org: recipientsMap[recipient.recipient]?.org,
            };
          });
        },
      )
      .finally(() => {
        offerModal.dataLoaded = true;
      });

    return $q(resolve => {
      $('#offer-modal').on('hidden.bs.modal', () => {
        clearOfferModal();
        resolve();
        $('#offer-modal').off();
      });
    });
  }

  function openFolderModal(folder, parentId) {
    folderModal.folder = folder || {};
    folderModal.folder = JSON.parse(JSON.stringify(folderModal.folder));
    folderModal.folder.parent = parentId;
    $('#folder-modal').modal({ keyboard: true });
    folderModal.open = true;

    return $q(resolve => {
      $('#folder-modal').on('hidden.bs.modal', () => {
        resolve(folderModal.updated);
        folderModal.updated = false;
        clearFolderModal();
        $('#folder-modal').off();
      });
    });
  }

  function openPlayerModal(file, updateFileName) {
    playerModal.file = file;
    playerModal.updateFileName = updateFileName;
    $('#player-modal').modal({ keyboard: true });
    playerModal.open = true;

    return $q(resolve => {
      $('#player-modal').on('hidden.bs.modal', () => {
        resolve();
        clearPlayerModal();
        $('#player-modal').off();
      });
    });
  }

  function openAddVideoModal(selectedFolderId) {
    addVideoModal.selectedFolderId = selectedFolderId;
    $('#add-video-modal').modal({ keyboard: true });
    addVideoModal.open = true;

    return $q(resolve => {
      $('#add-video-modal').on('hidden.bs.modal', () => {
        resolve(addVideoModal.updated);
        addVideoModal.updated = false;
        clearAddVideoModal();
        $('#add-video-modal').off();
      });
    });
  }

  function openAppointmentFilterModal(preferences) {
    appointmentFilterModal.preferences = preferences;
    $('#appointment-filter-modal').modal({ keyboard: true });
    appointmentFilterModal.open = true;

    return $q(resolve => {
      $('#appointment-filter-modal').on('hidden.bs.modal', () => {
        resolve({
          preferences: appointmentFilterModal.updatedPreferences,
          updated: appointmentFilterModal.updated,
        });
        clearAppointmentFilterModal();
        $('#appointment-filter-modal').off();
      });
    });
  }

  function openUserActionModal(userId) {
    userActionModal.userId = userId;
    $('#user-action-modal').modal({ keyboard: true });
    userActionModal.open = true;
    userService
      .getUserActions(userId, 1)
      .then(({ actions, count }) => {
        userActionModal.actions = actions;
        userActionModal.count = count;
      })
      .catch(err => {
        ErrorService.toastyHTTPErr(err);
      });

    return $q(resolve => {
      $('#user-action-modal').on('hidden.bs.modal', () => {
        clearUserActionModal();
        resolve();
        $('#user-action-modal').off();
      });
    });
  }

  function addContactModalListener(fn) {
    contactModal.changeEventListeners.push(fn);
  }

  function openContactModal() {
    if (contactModal.changeEventListeners) {
      contactModal.changeEventListeners.forEach(listener => listener(true));
      contactModal.open = true;
    }
  }

  function closeAssetModal() {
    assetModal.open = false;
    assetModal.index = null;
    assetModal.assets = null;
  }

  function closePreviewModal() {
    $('#preview-modal').modal('hide');
    clearPreviewModal();
  }

  function closeNetworkModal(removed) {
    networkModal.remove = removed;
    $('#network-modal').modal('hide');
    clearNetworkModal();
  }

  function closeAppointmentModal(updated) {
    appointmentModal.updated = updated;
    $('#appointment-modal').modal('hide');
    clearAppointmentModal();
  }

  function onCloseAppointmentConfigModal(fn) {
    appointmentConfigModal.closeEventListeners.push(fn);
  }
  function closeAppointmentConfigModal() {
    $('#appointment-config-modal').modal('hide');
    clearAppointmentConfigModal();
  }

  function closeMultiConfModal(contacts) {
    multiConfModal.updatedContacts = contacts;
    $('#multi-conf-modal').modal('hide');
    clearMultiConfModal();
  }

  function closeQuestionEditModal(question) {
    questionEditModal.updatedQuestion = question;
    $('#question-edit-modal').modal('hide');
    clearQuestionEditModal();
  }

  function closeOfferModal() {
    $('#offer-modal').modal('hide');
    clearOfferModal();
  }

  function closeFolderModal(updated) {
    folderModal.updated = updated;
    $('#folder-modal').modal('hide');
    clearFolderModal();
  }

  function closePlayerModal() {
    $('#player-modal').modal('hide');
    clearPlayerModal();
  }

  function closeAddVideoModal(updated) {
    addVideoModal.updated = updated;
    $('#add-video-modal').modal('hide');
    clearAddVideoModal();
  }

  function closeAppointmentFilterModal(preferences, updated) {
    appointmentFilterModal.updatedPreferences = preferences;
    appointmentFilterModal.updated = updated;
    $('#appointment-filter-modal').modal('hide');
    clearAppointmentFilterModal();
  }

  function closeUserActionModal() {
    $('#user-action-modal').modal('hide');
    clearUserActionModal();
  }

  function removeContactModalListener(fn) {
    contactModal.changeEventListeners =
      contactModal.changeEventListeners.filter(listener => listener !== fn);
  }

  function closeContactModal() {
    if (contactModal.changeEventListeners) {
      contactModal.changeEventListeners.forEach(listener => listener(false));
      contactModal.changeEventListeners = [];
    }
    contactModal.open = false;
  }

  return {
    openPreviewModal,
    closePreviewModal,
    previewModal,

    openNetworkModal,
    closeNetworkModal,
    networkModal,

    openAssetModal,
    closeAssetModal,
    assetModal,

    openAppointmentModal,
    closeAppointmentModal,
    appointmentModal,

    openAppointmentConfigModal,
    closeAppointmentConfigModal,
    appointmentConfigModal,
    onOpenAppointmentConfigModal,
    onCloseAppointmentConfigModal,

    openMultiConfModal,
    closeMultiConfModal,
    multiConfModal,

    openQuestionEditModal,
    closeQuestionEditModal,
    questionEditModal,

    openOfferModal,
    closeOfferModal,
    offerModal,

    openFolderModal,
    closeFolderModal,
    folderModal,

    openPlayerModal,
    closePlayerModal,
    playerModal,

    openAddVideoModal,
    closeAddVideoModal,
    addVideoModal,

    openAppointmentFilterModal,
    closeAppointmentFilterModal,
    appointmentFilterModal,

    openUserActionModal,
    closeUserActionModal,
    userActionModal,

    openContactModal,
    closeContactModal,
    contactModal,
    addContactModalListener,
    removeContactModalListener,
  };
}

export {};
